<template>
  <confirm-modal />
  <form
    v-if="isInterview"
    @submit.prevent
  >
    <div class="card my-5">
      <div class="row align-items-center justify-content-between">
        <div class="card-title col-auto mb-3">
          <img
            v-if="!paymentForInterview"
            src="~@/assets/img/chevron-down-solid.svg"
            alt="Futuro | Consultoria Financeira"
            @click="paymentForInterview = !paymentForInterview"
          >
          <img
            v-if="paymentForInterview"
            src="~@/assets/img/chevron-up-solid.svg"
            alt="Futuro | Consultoria Financeira"
            @click="paymentForInterview = !paymentForInterview"
          >
          <h2>Forma de investimento</h2>
        </div>
        <spinner
          v-if="loading"
          class="mr-2"
        />
      </div>
      <template v-if="paymentForInterview">
        <div
          v-if="
            calculation &&
              calculation.parcels_values &&
              paymentForInterview &&
              !loading
          "
          class="row justify-content-center my-5"
        >
          <div
            class="col-auto m-3 blue-card payment-card-vista"
            :class="{ selected: parcelsQuantity === 1, clickable: !isDetail }"
            @click="changeParcelsQuantity(1)"
          >
            <div class="h-100 inner-section">
              <div class="ribbon">
                <span class="ribbon__content"> MAIS ESCOLHIDO </span>
              </div>
              <h1 class="mb-3">
                Investimento à vista
              </h1>
              <p class="mb-3">
                <b v-if="!isOnlySubscription">{{
                  formatCurrency(
                    calculation.parcels_values["0"].total_amount,
                    "BRL"
                  )
                }}</b>
                <template v-if="!isOnlyConsulting && calculation.subscription_amount">
                  <br v-if="!isOnlySubscription">
                  <b>+{{
                    formatCurrency(calculation.subscription_amount, "BRL")
                  }}</b>
                  mensal da assinatura
                </template>
              </p>
              <p
                v-if="!isOnlySubscription"
                class="final-value"
              >
                {{
                  formatCurrency(
                    calculation.parcels_values["0"].discount,
                    "BRL"
                  )
                }}
                <br>
                desconto total
              </p>
            </div>
          </div>
          <div
            class="col-auto m-3 blue-card payment-card-parcelado"
            :class="{ selected: parcelsQuantity > 1, clickable: !isDetail }"
            @click="selectInstallmentInvestment()"
          >
            <div class="h-100 inner-section">
              <h1>Investimento parcelado</h1>
              <div v-if="!isOnlySubscription" class="w-100 px-3">
                <select
                  v-model.number="selectedParcel"
                  :disabled="isDetail"
                  class="form-select"
                  :class="{ 'select-disabled': isDetail }"
                  @change="onChangeParcels($event)"
                >
                  <option
                    v-for="parcel in parcels"
                    :key="parcel"
                    :value="parcel"
                  >
                    {{ parcel }} vezes
                  </option>
                </select>
              </div>
              <p>
                <template v-if="!isOnlySubscription">
                  {{
                    formatCurrency(
                      calculation.parcels_values[(selectedParcel - 1).toString()]
                        .installment_amount,
                      "BRL"
                    )
                  }}
                  por {{ selectedParcel }} meses
                </template>
                <template v-if="!isOnlyConsulting && calculation.subscription_amount">
                  <template v-if="!isOnlySubscription"> + </template>
                  {{ formatCurrency(calculation.subscription_amount, "BRL") }}
                  mensais
                </template>
              </p>
              <p
                v-if="
                  !isOnlySubscription &&
                    calculation.parcels_values[(selectedParcel - 1).toString()]
                      .discount > 0
                "
                class="final-value"
              >
                {{
                  formatCurrency(
                    calculation.parcels_values[(selectedParcel - 1).toString()]
                      .discount,
                    "BRL"
                  )
                }}
                <br>
                desconto total
              </p>
            </div>
          </div>
        </div>
        <div
          v-if="!loading"
          class="row"
        >
          <div class="col-12">
            <button
              :disabled="loading"
              class="btn btn-outline-light col-auto mx-2 exit"
              @click.prevent="discountsOpened = !discountsOpened"
            >
              <img
                v-if="!discountsOpened"
                src="~@/assets/img/chevron-down-solid.svg"
                alt=""
                height="15"
              >
              <img
                v-if="discountsOpened"
                src="~@/assets/img/chevron-up-solid.svg"
                alt=""
                height="15"
              >
            </button>
          </div>
          <div
            v-if="discountsOpened"
            class="col-12"
          >
            <div class="row mt-3">
              <div class="col-md-4 col-12">
                <label
                  for="investmentPercentage"
                  class="form-label"
                >
                  Acréscimo com base no patrimônio líquido
                </label>
                <input
                  id="investmentPercentage"
                  v-model.lazy="investmentPercentage"
                  v-money="percentageFormat"
                  type="text"
                  class="form-control"
                  :disabled="isDetail"
                  :class="{ 'is-invalid': v$.investmentPercentage.$error }"
                  @blur="preSave()"
                >
                <div class="invalid-feedback">
                  <span v-if="v$.investmentPercentage.minLength.$invalid">
                    O valor é inválido
                  </span>
                  <span v-if="v$.investmentPercentage.outOfBounds.$invalid">
                    O valor de acréscimo deve ser até 1,5%
                  </span>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <label
                  for="discountPercentage"
                  class="form-label"
                >
                  Desconto sob valor do projeto financeiro
                </label>
                <input
                  id="discountPercentage"
                  v-model.lazy="discountPercentage"
                  v-money="percentageFormat"
                  type="text"
                  class="form-control"
                  :disabled="isDetail"
                  :class="{ 'is-invalid': v$.discountPercentage.$error }"
                  @blur="preSave()"
                >
                <div class="invalid-feedback">
                  <span v-if="v$.discountPercentage.minLength.$invalid">
                    O valor é inválido
                  </span>
                  <span v-if="v$.discountPercentage.outOfBounds.$invalid">
                    O valor de desconto deve ser até 30%
                  </span>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <label
                  for="additionPercentage"
                  class="form-label"
                >
                  Acréscimo sob valor do projeto financeiro
                </label>
                <input
                  id="additionPercentage"
                  v-model.lazy="additionPercentage"
                  v-money="percentageFormat"
                  type="text"
                  class="form-control"
                  :disabled="isDetail"
                  :class="{ 'is-invalid': v$.additionPercentage.$error }"
                  @blur="preSave()"
                >
                <div class="invalid-feedback">
                  <span v-if="v$.additionPercentage.minLength.$invalid">
                    O valor é inválido
                  </span>
                  <span v-if="v$.additionPercentage.outOfBounds.$invalid">
                    O valor de acréscimo deve ser até 30%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </form>
</template>

<script>
import _ from "lodash";
import useVuelidate from "@vuelidate/core";
import {
  helpers,
  required,
  email,
  requiredIf,
  minLength,
} from "@vuelidate/validators";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { getProposalPayload } from "@/helpers/interview_payloads";
import { getPercentageFormat } from "@/helpers/formatting";
import * as types from "../store/types";
import * as accountTypes from "@/modules/account/store/types";
import { floatToPercentage, percentageToFloat } from "@/helpers/converters";
import Spinner from "@/modules/shared/components/Spinner";
import Presentation from "@/modules/shared/components/Presentation";
import SubscriptionPlans from "./SubscriptionPlans";
import ConfirmModal from "@/modules/shared/components/ConfirmModal";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import { isBackofficeRole } from "@/constants/auth";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
export default {
  components: {
    Spinner,
    Presentation,
    SubscriptionPlans,
    ConfirmModal,
    Swiper,
    SwiperSlide,
  },
  props: {
    interviewSection: {
      type: String,
      default: "",
    },
    isInterview: {
      type: Boolean,
      default: false,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const parcels = _.range(2, 13);
    const onSwiper = (swiper) => {};
    const onSlideChange = () => {};
    return {
      parcels,
      v$: useVuelidate({ $registerAs: props.interviewSection }),
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
  data() {
    return {
      selectedParcel: 6,
      parcelsQuantity: 1,
      interest: 0,
      totalAmount: 0,
      installmentAmount: 0,
      consultantId: undefined,
      userConsultantId: undefined,
      discount: 0,
      recommendationDiscount: 0,
      servicesToContract: "",
      partnerAsSigner: false,
      paymentMethod: "",
      supportFromAnotherConsultant: "no",
      closerConsultantId: undefined,
      token: "",
      loading: false,
      subscriptionPlansVisible: false,
      paymentForInterview: false,
      ownerLevel: undefined,
      loadingProposal: false,
      loadingRecs: false,
      errorPhone: false,
      cellPhoneWithError: [],
      onlySubscriptionKey: "only_subscription",
      discountsOpened: false,
      investmentPercentage: "",
      discountPercentage: "",
      additionPercentage: "",
      subscriptionPlanId: null,
      premiumAmount: 0,
    };
  },
  validations() {
    return {
      selectedParcel: {},
      parcelsQuantity: {},
      servicesToContract: { required },
      closerConsultantId: {
        required: requiredIf(function () {
          return this.supportFromAnotherConsultant === "yes";
        }),
      },
      investmentPercentage: {
        minLength: minLength(7),
        outOfBounds: function (value) {
          const convertedValue = percentageToFloat(value);
          return convertedValue >= 0 && convertedValue <= 1.5;
        },
      },
      discountPercentage: {
        minLength: minLength(7),
        outOfBounds: function (value) {
          const convertedValue = percentageToFloat(value);
          return convertedValue >= 0 && convertedValue <= 30;
        },
      },
      additionPercentage: {
        minLength: minLength(7),
        outOfBounds: function (value) {
          const convertedValue = percentageToFloat(value);
          return convertedValue >= 0 && convertedValue <= 30;
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      goals: types.GOALS,
      paymentMethodTypes: types.PAYMENT_METHOD_TYPES,
      calculation: types.PROPOSAL_CALCULATION,
      proposal: types.PROPOSAL,
      isAnalyst: accountTypes.IS_HUNTER,
      isPn: accountTypes.IS_PN,
      user: accountTypes.USER,
      subscriptionPlans: types.SUBSCRIPTION_PLANS,
      formatCurrency: types.FORMAT_CURRENCY,
      proposalPercentages: types.PROPOSAL_PERCENTAGES,
    }),
    isOnlyConsulting() {
      return this.proposal?.services_to_contract === 'only_consulting';
    },
    isOnlySubscription() {
      return this.proposal?.services_to_contract === this.onlySubscriptionKey;
    },
    payments: function () {
      if (!this.paymentMethodTypes) return {};
      return Object.fromEntries(
        Object.entries(this.paymentMethodTypes).filter(
          ([key, value]) =>
            this.parcelsQuantity === 1 ||
            (this.parcelsQuantity > 1 && key === "credit")
        )
      );
    },
    differentConsultant: function () {
      return this.userConsultantId != this.consultantId && !this.isAnalyst && !this.isBackoffice;
    },
    discount0: function () {
      return this.calculation?.discount_value_0 || 0;
    },
    discount5: function () {
      return this.calculation?.discount_value_5 || 0;
    },
    discount10: function () {
      return this.calculation?.discount_value_7_5 || 0;
    },

    discount15: function () {
      return this.calculation?.discount_value_10 || 0;
    },
    breakpoints() {
      return {
        768: {
          slidesPerView: 1.5,
        },
        992: {
          slidesPerView: 2.5,
        },
        1200: {
          slidesPerView: 3,
        },
        1400: {
          slidesPerView: this.subscriptionPlans?.length || 4,
        },
      };
    },
    percentageFormat: function () {
      return getPercentageFormat();
    },
    isBackoffice: function () {
      return isBackofficeRole(this.user?.user?.user_role_id);
    },
  },
  watch: {
    selectedParcel(val) {
      if (val > 1) this.changeParcelsQuantity(val);
    },
    proposalPercentages: {
      deep: true,
      handler(newVal) {
        // Sincroniza do store para as variáveis locais (quando outro componente atualiza)
        if (newVal.investmentPercentage !== undefined && newVal.investmentPercentage !== this.investmentPercentage) {
          this.investmentPercentage = newVal.investmentPercentage;
        }
        if (newVal.discountPercentage !== undefined && newVal.discountPercentage !== this.discountPercentage) {
          this.discountPercentage = newVal.discountPercentage;
        }
        if (newVal.additionPercentage !== undefined && newVal.additionPercentage !== this.additionPercentage) {
          this.additionPercentage = newVal.additionPercentage;
        }
        if (newVal.recommendationDiscount !== undefined && newVal.recommendationDiscount !== this.recommendationDiscount) {
          this.recommendationDiscount = newVal.recommendationDiscount;
        }
      },
    },
  },
  async mounted() {
    if (this.isAnalyst && this.supportFromAnotherConsultant === "no") {
      this.supportFromAnotherConsultant = "yes";
    }
    this.token = this.$route.params.customerId;
    await this.fetchAll();
  },
  emits: ['parcels-change'],
  methods: {
    ...mapActions({
      getProposal: types.GET_PROPOSAL,
      getCustomerInfo: types.GET_CUSTOMER_INFO,
      autoSaveProposal: types.AUTO_SAVE_PROPOSAL,
      calculateProposal: types.CALCULATE_PROPOSAL,
    }),
    ...mapMutations({
      mutateProposal: types.MUTATE_PROPOSAL,
      changeLoadingState: types.MUTATE_INTERVIEW_PROPOSAL_LOADING,
      setProposalPercentages: types.MUTATE_PROPOSAL_PERCENTAGES,
    }),
    async fetchProposal() {
      this.loading = true;
      try {
        const response = await this.getProposal(this.$route.params.customerId);
        const {
          installment_quantity,
          services_to_contract,
          payment_method,
          closer_consultant_id,
          interest,
          total_amount,
          installment_amount,
          discount,
          recommendation_discount,
          partner_as_signer,
          investment_percentage,
          discount_percentage,
          addition_percentage,
          subscription_plan_id,
          subscription_amount,
        } = response.data;
        this.setProposalPercentages({
          investmentPercentage: floatToPercentage(investment_percentage),
          discountPercentage: floatToPercentage(discount_percentage),
          additionPercentage: floatToPercentage(addition_percentage),
          recommendationDiscount: recommendation_discount || 0,
        });
        this.selectedParcel =
          installment_quantity > 1 ? installment_quantity : 6;
        this.servicesToContract = services_to_contract;
        this.paymentMethod = payment_method;
        this.interest = interest;
        this.totalAmount = total_amount;
        this.installmentAmount = installment_amount;
        this.discount = discount;
        this.recommendationDiscount = recommendation_discount || 0;
        this.partnerAsSigner = Boolean(partner_as_signer);
        this.subscriptionPlanId = subscription_plan_id;
        this.premiumAmount = Number(subscription_amount) || 0;
        const customerInfoResponse = await this.getCustomerInfo(
          this.$route.params.customerId
        );
        this.consultantId = customerInfoResponse.data?.consultant_id;
        this.userConsultantId = this.user?.user?.appify_consultant_id;
        this.ownerLevel =
          customerInfoResponse.data?.customer_consultant?.id_consultant_role;
          
        if (
          this.isAnalyst ||
          closer_consultant_id ||
          this.differentConsultant
        ) {
          this.supportFromAnotherConsultant = "yes";
        } else {
          this.supportFromAnotherConsultant = "no";
        }
        
        if (closer_consultant_id) {
          this.closerConsultantId = closer_consultant_id;
        } else if (this.differentConsultant) {
          this.closerConsultantId = this.userConsultantId;
        }
        this.changeParcelsQuantity(installment_quantity);
        const payload = getProposalPayload(this);
        this.mutateProposal(payload);
      } catch (error) {
        this.$vfm.show("message", {
          type: "error",
          messages: [
            "Não foi possível obter a proposta do cliente.",
            "Entre em contato com o time de TI antes de prosseguir com a operação.",
          ],
        });
      } finally {
        this.loading = false;
        this.changeLoadingState(false);
      }
    },
    async fetchAll() {
      this.changeLoadingState(true);
      try {
        await Promise.all([
          this.fetchProposal(),
        ]);
      } catch (error) {
      } finally {
        this.changeLoadingState(false);
      }
    },
    preSave() {
      // Atualiza o store com os valores locais
      this.setProposalPercentages({
        investmentPercentage: this.investmentPercentage,
        discountPercentage: this.discountPercentage,
        additionPercentage: this.additionPercentage,
        recommendationDiscount: this.recommendationDiscount,
      });
      
      const payload = getProposalPayload({
        ...this,
        investmentPercentage: this.investmentPercentage,
        discountPercentage: this.discountPercentage,
        additionPercentage: this.additionPercentage,
        recommendationDiscount: this.recommendationDiscount,
      });
      const currentPayload = JSON.stringify(payload);
      if (this.tempPayload !== currentPayload) {
        this.tempPayload = currentPayload;
        this.mutateProposal(payload);
        this.autoSave(payload);
      }
    },
    async autoSave(payload) {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;
      this.autoSaveProposal(payload)
        .then((response) => {
          this.calculate();
        })
        .catch((error) => {
          this.$vfm.show("message", {
            type: "error",
            messages: [
              "Não foi possível salvar automaticamente a proposta do cliente.",
              "Entre em contato com o time de TI antes de prosseguir com a operação.",
            ],
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    syncFromExternalCloserConsultant({ supportFromAnotherConsultant, closerConsultantId }) {
      this.supportFromAnotherConsultant = supportFromAnotherConsultant;
      this.closerConsultantId = closerConsultantId;
      this.preSave();
    },
    onChangeParcels(event) {
      const v = Number(event.target.value);
      this.changeParcelsQuantity(v);
    },
    selectInstallmentInvestment() {
      this.changeParcelsQuantity(this.selectedParcel);
    },
    changeParcelsQuantity(value) {
      if (!this.isDetail) {
        const v = Number(value);
        if (this.parcelsQuantity !== v) {
          this.paymentMethod = "credit";
        }
        this.parcelsQuantity = v;
        if (v > 1) this.selectedParcel = v;
        if (this.calculation?.parcels_values) {
          const parcelValues =
            this.calculation.parcels_values[
              (Number(this.parcelsQuantity) - 1).toString()
            ];
          this.interest = parcelValues.interest;
          this.totalAmount = parcelValues.total_amount;
          this.installmentAmount = parcelValues.installment_amount;
          this.discount = parcelValues.discount;
        }
        this.$emit('parcels-change', {
          parcelsQuantity: this.parcelsQuantity,
          selectedParcel: this.selectedParcel,
        });
      }
    },
    calculate() {
      this.loading = true;
      this.calculateProposal(this.token)
        .catch((error) => {
          this.$vfm.show("message", {
            type: "error",
            messages: [
              "Não foi possível obter os dados de proposta do cliente.",
              "Entre em contato com o time de TI antes de prosseguir com a operação.",
            ],
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 800px) {
  .ribbon {
    padding-right: 295px !important;
  }
}
.blue-card {
  padding: 30px 20px;
  width: 500px;
  height: 300px;
  &.payment-card-vista,
  &.payment-card-parcelado {
  background-color: rgba(24, 29, 47, 0.7) !important;
  }
  h1 {
    font-size: 25px !important;
    font-weight: 600;
    text-align: center;
  }
}
.final-value {
  font-size: 26px !important;
  line-height: 1.2 !important;
  font-weight: 600;
  color: #ffeb98;
}
.ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  padding-right: 515px;
  padding-bottom: 315px;
}
.ribbon__content {
  left: -50px;
  top: 30px;
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
  position: absolute;
  display: block;
  width: 225px;
  padding: 10px 0;
  background-color: var(--orange);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-align: center;
  border: 2px dotted #fff;
  outline: 5px solid var(--orange);
}
.ribbon::before {
  top: 0;
  left: 0;
  border-top-color: transparent;
  border-right-color: transparent;
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  box-sizing: content-box;
}
.ribbon::after {
  bottom: 0;
  right: 0;
  border-top-color: transparent;
  border-right-color: transparent;
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid #f19066;
}

.error-bg {
  background-color: rgba(220, 53, 69, 0.8);
}

.margin-button {
  margin-top: 35px;
}

@media (max-width: 767.98px) {
  .column-mobile {
    flex-direction: column-reverse;
  }

  .margin-button {
    margin-top: 0px;
  }
}

option:disabled {
  background-color: #f0f0f0 !important; /* Change the background color */
  color: #ccc !important; /* Change the text color */
}
</style>
